import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitFirmwareModel } from '@apps-common/types/management/unit-firmware'

export const updateUnitFirmware = async (model: IUnitFirmwareModel): Promise<IUnitFirmwareModel> =>
  axios.post(`/management/unitfirmware/updateunitfirmware`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitFirmwareModel
}

export const useManagementUpdateUnitFirmware = (notify?: boolean, onSuccess?: (data: IUnitFirmwareModel) => void) =>
  useMutation({
    mutationKey: ['updateUnitFirmware'],
    mutationFn: ({ model }: Props) => updateUnitFirmware(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated device firmware.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update device firmware, please try again.')
      }
    },
    throwOnError: false
  })
